import React, { useEffect, useRef } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

import { pauseSubscriptionAction } from 'root-redux/actions/user'
import { selectUUID } from 'root-redux/selects/user'
import { TAppDispatch } from 'root-redux/store/store'

import { PAUSE_SUBSCRIPTION_OPTION_VALUES } from 'modules/unsubscribe/pages/PauseSubscription/constants'

import { eventLogger } from 'services/eventLogger.service'

import { goTo } from 'browser-history'
import { PageId } from 'page-constants'

import { FlowFeedbackPopup } from '../../components/FlowFeedbackPopup'
import { FlowOption } from '../../components/FlowOption'
import { FlowPageContainer } from '../../components/FlowPageContainer'
import { useCancelSubscription } from '../../hooks/useCancelSubscription'
import { useRetentionFlowV2Config } from '../../hooks/useRetentionFlowV2Config'
import { FlowContent, FlowOptions } from '../../styles'
import { StyledFlowPauseSubscription as S } from './FlowPauseSubscription.styles'

export const FlowPauseSubscription: React.FC = () => {
  const { search } = useLocation()
  const { t } = useTranslation()
  const { copyKey } = useRetentionFlowV2Config()
  const dispatch: TAppDispatch = useDispatch()
  const userId = useSelector(selectUUID)

  const {
    isFeedbackPopupShown,
    closeFeedbackPopup,
    cancelSubscription,
    goToCancellation,
  } = useCancelSubscription()
  const isSubmittedRef = useRef(false)

  useEffect(() => {
    eventLogger.logPauseSubscriptionScreenShow(userId)
  }, [userId])

  const handlePause = () => {
    if (isSubmittedRef.current) return

    isSubmittedRef.current = true
    eventLogger.logPauseSubscriptionScreenClose(
      PAUSE_SUBSCRIPTION_OPTION_VALUES.YES,
      userId,
    )
    dispatch(pauseSubscriptionAction())
    goTo({ pathname: PageId.CONTINUED_SUBSCRIPTION, search })
  }

  const handleDecline = () => {
    eventLogger.logPauseSubscriptionScreenClose(
      PAUSE_SUBSCRIPTION_OPTION_VALUES.NO,
      userId,
    )
    goToCancellation()
  }

  return (
    <FlowPageContainer hasNavigation>
      <FlowContent>
        <S.Description>
          <Trans
            i18nKey={`${copyKey}.pauseSubscription.description`}
            components={{ br: <br />, strong: <strong /> }}
          />
        </S.Description>
        <S.Title isAlignedLeft>
          {t(`${copyKey}.pauseSubscription.title`)}
        </S.Title>
        <FlowOptions>
          <FlowOption onClick={handlePause}>
            {t(`${copyKey}.pauseSubscription.yes`)}
          </FlowOption>
          <FlowOption onClick={handleDecline}>
            {t(`${copyKey}.pauseSubscription.no`)}
          </FlowOption>
        </FlowOptions>
      </FlowContent>
      <FlowFeedbackPopup
        isShown={isFeedbackPopupShown}
        onComplete={cancelSubscription}
        onClose={closeFeedbackPopup}
      />
    </FlowPageContainer>
  )
}
